import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider, App as AntApp } from 'antd';
import { queryClient } from '@/services/query-client';
import { getThemeConfig } from '@/styles/theme';
import { useUIStore } from '@/stores/ui.store';

export function Providers({ children }: { children: React.ReactNode }) {
  const themeMode = useUIStore((s) => s.themeMode);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={getThemeConfig(themeMode)}>
        <AntApp>
          {children}
        </AntApp>
      </ConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
